var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading || _vm.isEmptyData)?_c('BaseLoading'):_c('FormSubHeaders',{attrs:{"is-edit-mode":true,"data":_vm.data,"sub-header-type":_vm.subHeaderType,"visibility-text-label":"Homepage visibility"},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }